import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

const NotFound = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const isLoggedIn = !!user;
  const roleId = Number(user?.role?.id);

  // Decide where to send the user based on their role
  const getDashboardPath = () => {
    if (roleId === 1) return "/dashboard";
    if ([2, 3, 4, 5, 6].includes(roleId)) return "/user/dashboard";
    return "/";
  };

  const handleClick = () => {
    if (isLoggedIn) {
      navigate(getDashboardPath());
    } else {
      navigate("/login");
    }
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.code}>404</h1>
      <h2 style={styles.title}>Page Not Found</h2>
      <p style={styles.text}>
        The page you are looking for does not exist or has been moved.
      </p>

      <button style={styles.button} onClick={handleClick}>
        {isLoggedIn ? "Go to Dashboard" : "Go to Login"}
      </button>
    </div>
  );
};

export default NotFound;

const styles = {
  container: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    background: "#f9fafb",
    textAlign: "center",
    padding: "20px",
  },
  code: {
    fontSize: "96px",
    fontWeight: "700",
    color: "#e11d48",
    margin: 0,
  },
  title: {
    fontSize: "28px",
    margin: "10px 0",
  },
  text: {
    color: "#6b7280",
    marginBottom: "20px",
  },
  button: {
    padding: "10px 24px",
    fontSize: "16px",
    background: "#2563eb",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
  },
};
